import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BankAccount } from '../core/state/earnings/bank-account.model';
import { catchError, of, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BankAccountApiService {
  private http = inject(HttpClient);
  private baseUrl = environment.host;

  get() {
    return this.http
      .get<BankAccount>(this.baseUrl + '/api/v1/bank-account')
      .pipe(
        catchError((err: HttpErrorResponse) => {
          if (err.status === 404) {
            return of(null);
          }
          return throwError(() => err);
        })
      );
  }

  save(data: Omit<BankAccount, '_id' | 'user'>) {
    return this.http.put<BankAccount>(
      this.baseUrl + '/api/v1/bank-account',
      {
        accountHolderName: data.accountHolderName,
        bankName: data.bankName,
        branchName: data.branchName,
        accountNumber: data.accountNumber,
        bankBookResource: data.bankBookResource
          ? typeof data.bankBookResource === 'string'
            ? data.bankBookResource
            : data.bankBookResource._id
          : undefined,
      }
    );
  }
}
